import React, { useRef, useEffect, useLayoutEffect } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Box from '../box';
import Tag from '../tag';

const MAX_PROGRESS = 100;

const Preloader = ({
  progress = 0,
  label = '',
  isRounded = false,
  isAnimated = false,
  indeterminate = false,
  onAnimationEnd = null,
}) => {
  const fill = useRef(null);

  const preloaderClassName = classNames('ws-ui-preloader', {
    'ws-ui-preloader--rounded': isRounded,
    'ws-ui-preloader--animated': isAnimated,
    'ws-ui-preloader--indeterminate': indeterminate,
  });

  useEffect(() => {
    if (!onAnimationEnd || !fill?.current || progress !== MAX_PROGRESS) return;
    const el = fill.current;

    el.addEventListener('transitionend', onAnimationEnd);

    // eslint-disable-next-line consistent-return
    return () => {
      el.removeEventListener('transitionend', onAnimationEnd);
    };
  }, [onAnimationEnd, progress]);

  useLayoutEffect(() => {
    requestAnimationFrame(() => {
      if (!fill.current || !progress) return;

      fill.current.style.width = `${progress}%`;
    });
  }, [progress]);

  return (
    <div className={preloaderClassName}>
      <div className="ws-ui-preloader__line">
        <div ref={fill} className="ws-ui-preloader__fill" />
      </div>
      {label && (
        <Box marginTop="spacing-3-xs">
          <Tag label={label} />
        </Box>
      )}
    </div>
  );
};

Preloader.propTypes = {
  progress: PropTypes.number,
  label: PropTypes.string,
  isRounded: PropTypes.bool,
  isAnimated: PropTypes.bool,
  indeterminate: PropTypes.bool,
  onAnimationEnd: PropTypes.func,
};

export default Preloader;
